import { ChangeDetectorRef, Component, inject, OnInit, Renderer2 } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { AuthServiceUser } from "../services/auth/auth.service";
import { ToastrService } from "ngx-toastr";
import { menuConfig } from "src/assets/config/constants";
import { LocalStorageService } from "../services/local-storage.service";
// import { AuthService } from '../_services/auth.service';
// import { AlertService } from '../_services/alert.service';

@Component({
    templateUrl: "login.component.html",
    styleUrls: ["./login.component.css"],
    standalone: false
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  isPhoneNumberVerified = false;
  loginRole = "admin";
  loginRoleOptions = [
    { id: "admin", name: "Admin / Zone Admin / Telecaller" },
    { id: "supplieradmin", name: "Supplier" },
    { id: "eventadmin", name: "Event Organizer" },
    { id: "templeadmin", name: "Temple Admin" },
  ];

  private readonly toastr = inject(ToastrService);
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthServiceUser,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private localStorage: LocalStorageService
  ) {

  }

  ngOnInit() {

    this.loginForm = this.formBuilder.group({
      phone: ["", Validators.required], //8019808860
      otp: [""],
    });

    this.renderer.selectRootElement('#phone').focus();
  }

  updateOtpValidator(): void {
    if (this.isPhoneNumberVerified) {
      this.loginForm.get("otp")?.setValidators([Validators.required]);
    } else {
      this.loginForm.get("otp")?.clearValidators();
    }
    this.loginForm.get("otp")?.updateValueAndValidity();
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  tryLogin() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.submitted = false;
      return;
    }

    if (!this.isPhoneNumberVerified) {
      this.verifyPhoneNumber();
      return;
    }
    const value = {
      phone: this.f.phone.value.trim(), //8019808860
      otp: this.f.otp.value.trim(),
    };
    this.authService.login(value, this.loginRole).subscribe({
      next: (data) => {
        if (data.success) {
          const firstViewMenu = this.getFirstViewModuleMenu(data.data.access, menuConfig);
          if (firstViewMenu) {
            if (firstViewMenu.submenu) {
              const firstSubMenu = firstViewMenu.submenu.items.find(item => item.pageType === 'view');
              if (firstSubMenu) {
                this.localStorage.setItem('firstMenu', firstSubMenu.page);
                this.router.navigate([firstSubMenu.page]);
              }
            } else {
              this.localStorage.setItem('firstMenu', firstViewMenu.page);
              this.router.navigate([firstViewMenu.page]);
            }
          } else {
            this.router.navigate(["/404"]);
          }
          this.submitted = false;
        }
      },
      error: (err) => {
        this.submitted = false;
        console.log(err);
        this.toastr.error(err.message, "", {
          timeOut: 3000,
        });
      },
    });
  }

  verifyPhoneNumber() {
    const value = { phone: this.f.phone.value.trim() };
    this.authService.verifyPhoneNumber(value, this.loginRole).subscribe({
      next: () => {
        this.isPhoneNumberVerified = true;
        // this.router.navigate(['/product/all']);
        // this.setUserInStorage({person:"krishna"});
        this.cdr.detectChanges();
        this.renderer.selectRootElement('#otp').focus();
        this.submitted = false;
      },
      error: (err) => {
        console.log(err);
        this.toastr.error(err.message, "", {
          timeOut: 3000,
        });
        this.submitted = false;
      }
    });
  }

  sendOTP() {
    const value = { phone: this.f.phone.value.trim() };
    this.authService.sendOTPAgain(value).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.toastr.success(res.message, "", {
            timeOut: 3000,
          });
        } else {
          this.toastr.error(res.message, "", {
            timeOut: 3000,
          });
        }
      },
      error: (err) => {
        console.log(err);
        this.toastr.error(err.message, "", {
          timeOut: 3000,
        });
        this.submitted = false;
      }
    });
  }

  onLoginRoleChange() {
    this.isPhoneNumberVerified = false;
    this.loginForm.get("otp")?.setValue("");
    this.submitted = false;
    this.updateOtpValidator();
    this.cdr.detectChanges();
    this.renderer.selectRootElement('#phone').focus();
  }

  setUserInStorage(res) {
    if (res.user) {
      localStorage.setItem("currentUser", res.user);
    } else {
      localStorage.setItem("currentUser", res);
    }
  }

  getFirstViewModuleMenu(access: Record<string, string[]>, menuItems: any[]): any | null {
    for (const [moduleKey, permissions] of Object.entries(access)) {
      if (permissions.includes('view')) {
        const found = menuItems.find(menu => {
          if (menu.module === moduleKey) return true;
          if (menu.submenu && Array.isArray(menu.submenu.items)) {
            return menu.submenu.items.some(item => item.module === moduleKey && item.pageType === 'view');
          }
          return false;
        });
        if (found) return found;
      }
    }
    return null; // No module with 'view' found in access
  }

  restrictToNumbers(event: KeyboardEvent, count = 10): void {
    const input = event.target as HTMLInputElement;

    // Allowed non-number keys
    const allowedKeys = [
      "Backspace",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
      "Tab"
    ];

    const isNumberKey = event.key >= "0" && event.key <= "9";

    if (!allowedKeys.includes(event.key)) {
      if (!isNumberKey || input.value.length >= count) {
        event.preventDefault();
      }
    }
  }
}
